
export const Shadows = {
    default: ' 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06) ',
    xxl: ' 0 25px 50px -12px rgba(0, 0, 0, 0.25) ',
    inner: ' inset 0 2px 4px 0 rgba(0, 0, 0, 0.06) ',
    lg: ' 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) ',
    md: ' 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) ',
    none: ' none ',
    outline: ' 0 0 0 3px rgba(118, 169, 250, 0.45) ',
    outlineBlue: ' 0 0 0 3px rgba(164, 202, 254, 0.45) ',
    outlineGray: ' 0 0 0 3px rgba(159, 166, 178, 0.45) ',
    outlineGreen: ' 0 0 0 3px rgba(132, 225, 188, 0.45) ',
    outlineIndigo: ' 0 0 0 3px rgba(180, 198, 252, 0.45) ',
    outlineOrange: ' 0 0 0 3px rgba(253, 186, 140, 0.45) ',
    outlinePink: ' 0 0 0 3px rgba(248, 180, 217, 0.45) ',
    outlinePurple: ' 0 0 0 3px rgba(202, 191, 253, 0.45) ',
    outlineRed: ' 0 0 0 3px rgba(248, 180, 180, 0.45) ',
    outlineTeal: ' 0 0 0 3px rgba(126, 220, 226, 0.45) ',
    outlineYellow: ' 0 0 0 3px rgba(250, 202, 21, 0.45) ',
    sm: ' 0 1px 2px 0 rgba(0, 0, 0, 0.05) ',
    solid: ' 0 0 0 2px currentColor ',
    xl: ' 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05) ',
    xs: ' 0 0 0 1px rgba(0, 0, 0, 0.05) ',
};


export const Roundings = {
    default: ' 0.25rem ',
    full: ' 9999px ',
    lg: ' 0.5rem ',
    md: ' 0.375rem ',
    sm: ' 0.125rem ',
};
